<template>
  <v-container id="pacote-list">
    <v-row>
      <v-col>Faixas</v-col>
      <v-col class="text-right">
        <v-btn outlined color="primary" class="ml-3" @click="add()">
          Adicionar Faixa
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <v-btn
                  @click="edit(item.faixaid)"
                  outlined
                  color="warning"
                  class="ml-3"
                >
                  <v-icon> mdi-pencil</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-delete :object="item" @on-save="loadPacotes">
                  <template v-slot:title> Deletar Faixa </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhum Faixa retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { faixaApi } from "@/apis";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";

export default {
  components: {
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "faixaNome" },
        { text: "Subsídio", value: "faixaSubsidio" },
        { text: "Teto", value: "faixaTeto" },
        { text: "Valor Combo Essencial", value: "valorFaixaEssencial" },
        { text: "Editar", value: "acoes", sortable: false, width: "5%" },
        {
          text: "Excluir",
          value: "acoes_delete",
          sortable: false,
          width: "5%",
        },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    add() {
      this.$router.push("/faixas/add");
    },
    edit(faixaId) {
      this.$router.push("/faixas/edit/" + faixaId);
    },
    loadPacotes() {
      this.setLoading(true);
      faixaApi
        .list()
        .then((resp) => {
          this.payload = resp.data;

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter faixas");
        });
    },
  },
  mounted() {
    this.loadPacotes();
  },

  computed: {
    ...mapGetters(["isFulladmin"]),
  },
};
</script>
